import { Dispatch } from 'redux'
import { CallbackArgs } from 'DVPAWebWidgetsDetailsPageClient'
import { Logger } from 'DVWebNodeUtils'
import { MessageTypes } from '@amzn/dvui/dist/Block'
import { DetailPageActionTypes } from './constants'
import { COUNTER_PACKAGE_PREFIX } from '../utils/utils'
import { DetailPageActions } from './index'
import { CallbackInput } from '../components/purchaseFlowWrapper/purchaseFlowWrapper'
import { createBanner } from './banner'
import { refreshActionBoxes } from './actionBox'

export interface ITriggerRefund {
  type: typeof DetailPageActionTypes.TriggerRefund
  payload: {
    titleId: string
  }
}

export interface IRefundFailed {
  type: typeof DetailPageActionTypes.RefundFailed
}

export interface IRefundCancelled {
  type: typeof DetailPageActionTypes.RefundCancelled
}

export const refundCancelled = ({ dispatch }: CallbackInput) =>
  dispatch({ type: DetailPageActionTypes.RefundCancelled })

export const refundFailed = ({ dispatch }: CallbackInput) => {
  dispatch({ type: DetailPageActionTypes.RefundFailed })
}

export const triggerRefund = (
  dispatch: Dispatch<DetailPageActions>,
  logger: Logger,
  titleId: string
) => {
  logger
    .info(`Initiating refund of titleId ${titleId}`)
    .count(`${COUNTER_PACKAGE_PREFIX}_Refund_Purchase`, 1, false)
  dispatch({
    type: DetailPageActionTypes.TriggerRefund,
    payload: {
      titleId
    }
  })
}

export type RefundStatus = 'Success' | 'Failure'
export const refundStatusCallback = (
  status: RefundStatus,
  args: CallbackArgs
) => async ({ dispatch }: CallbackInput) => {
  await refreshActionBoxes()

  if ((((args || {}).clientContract || {}).taskData || {}).viewData) {
    const { title, message } = args.clientContract.taskData.viewData
    dispatch(
      createBanner({
        type:
          status === 'Success' ? MessageTypes.success : MessageTypes.warning,
        string: message,
        heading: title
      })
    )
  }
}
